import { SOURCEAIS } from "../../actions/portal/";

export default function(state = "GPS", action) {
  switch (action.type) {
    case SOURCEAIS:
      return action.payload;
    default:
  }

  return state;
}
